import React, { Component } from "react";
import { withApollo } from "react-apollo";
import PropTypes from "prop-types";
import { Typography, Row, Col, Form, Table } from "antd";
import { changeFormatdate } from "../../../../../../utils/formatdate";
import { numberWithCommas } from "../../../../../../utils/number";

class WelfareInTermFeeHistory extends Component {
  state = {
    columns: [
      {
        title: "วันที่ยื่นเรื่อง",
        dataIndex: "submitDate",
        align: "center",
        render: (item, record, index) => (item ? changeFormatdate(item) : "-"),
      },
      {
        title: "ปีการศึกษา",
        dataIndex: "studyEducationFeeYear",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "ภาคการศึกษา",
        dataIndex: "studyEducationFeeTerm",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "จำนวนเงินในใบเสร็จ (บาท)",
        dataIndex: "studyEducationFeeTotalAmount",
        align: "center",
        render: (item, record, index) => (item ? numberWithCommas(item) : "-"),
      },
      {
        title: "จำนวนเงินที่เบิกได้ทั้งหมด (บาท)",
        dataIndex: "studyEducationFeeTotalPaid",
        align: "center",
        render: (item, record, index) => (item ? numberWithCommas(item) : "-"),
      },
      {
        title: "วันที่จ่าย",
        dataIndex: "studyEducationPaidDate",
        align: "center",
        render: (item, record, index) => (item ? changeFormatdate(item) : "-"),
      },
      {
        title: "สถานะเอกสาร",
        dataIndex: "studyEducationPaidStatusName",
        align: "center",
        render: (item, record, index) => item || "-",
      },
    ],
  };

  render() {
    const { columns } = this.state;
    const { dataTermfeeHistory } = this.props;
    const studyEducationFeePaidHistoryList =
      dataTermfeeHistory?.studyEducationFeePaidHistoryList || [];

    return (
      <Row gutter={16} type="flex" justify="left" align="top" className="py-2">
        <Col md={24} className="mb-3">
          <Typography.Text className="color-red">
            <span style={{ fontSize: "18px" }}>ประวัติการเบิก</span>
          </Typography.Text>
        </Col>
        <Col md={24} className="mb-2">
          <Table
            locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
            columns={columns}
            dataSource={studyEducationFeePaidHistoryList}
            pagination={false}
            scroll={{ x: "max-content" }}
            rowKey="studyEducationFeeId"
          />
        </Col>
        <Col span={24} className="flex-end align-center">
          <span>{`จำนวนเงินที่ใช้ไป : `}</span>
          <span style={{ width: 123, textAlign: "right" }}>
            {`${numberWithCommas(dataTermfeeHistory?.totalPaid || 0)} บาท`}
          </span>
        </Col>
        <Col span={24} className="flex-end align-center">
          <span>{`จำนวนเงินคงเหลือที่เบิกได้ : `}</span>
          <span style={{ width: 123, textAlign: "right" }}>
            {`${numberWithCommas(dataTermfeeHistory?.totalBalance || 0)} บาท`}
          </span>
        </Col>
      </Row>
    );
  }
}

WelfareInTermFeeHistory.defaultProps = {
  autoFocus: false,
};

WelfareInTermFeeHistory.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareInTermFeeHistory = Form.create()(WelfareInTermFeeHistory);

export default withApollo(WrappedWelfareInTermFeeHistory);
